<div *ngIf="trigger">
  <div *ngFor="let _ of skeletons" class="tileSkeletonContainer">
    <ion-skeleton-text
      animated="true"
      class="tileSkeleton"
    ></ion-skeleton-text>
  </div>
</div>
